export default "__VITE_ASSET__CUQsw7SG__"